import { Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MainSetup from './main';
import ScheduleSetup from './schedule/schedule';
import { getForm } from './formSlice';
import Messages from './Messages/Messages';
import Design from './Design/Design';

const Components = {
  main: MainSetup,
  design: Design,
  schedule: ScheduleSetup,
  messages: Messages,
};
const FormSetup = () => {
  const [searchParams] = useSearchParams();
  const form = useSelector(getForm);
  const Component = Components[searchParams.get('a')] || MainSetup;

  return (
    <Flex direction="column" minH="250px">
      <Component form={form} />
    </Flex>
  );
};

export default FormSetup;
